import * as React from 'react';
import Form from 'myshubhlife-component/form';
import 'login/TwoFactorLogin/styles.scss';
import {Snackbar} from "web-com";

export interface IForm {
  fields: IFormField[];
  identifier: string;
  buttonlabel: string;
  inputStyleType: string;
}

interface IFormField {
  fields: IField[];
  identifier: string;
}

interface IField {
  identifier: string;
  label?: string;
  type: string;
  max?: number;
  regex?: string | RegExp;
  value?: string | number | string[];
  otpLength?: number;
  otpType?: string;
  otp?: string[];
}

interface ITwoFactorLoginProps {
  logo: string;
  message: string;
  form: IForm;
  onFormChange: (index: number, value: string | number | string[] | boolean, formindex: number, fieldname: string) => void;
  onFormSubmit: () => void;
  onErrorClose: (e: boolean) => void;
  error: string;
}

const TwoFactorLogin = (props: ITwoFactorLoginProps) => {
  const onFormSubmit = () => {
    props.onFormSubmit();
  };

  const onFormChange = (index: number, value: string | number | string[] | boolean, formindex: number, fieldname: string) => {
    props.onFormChange(index, value, formindex, fieldname);
  };

  return (
    <div className="login-form-container container-fluid">
      <div className="row justify-content-center">
        <div className="card col-11 login-form-card">
          <div className="card-body">
            <Snackbar
              type="danger"
              show={!!props.error}
              onCloseHandler={props.onErrorClose}
              timeout={5000}
            >
              {props.error}
            </Snackbar>
            <div className="two-factor-logo-wrapper">
              {props.logo && <img className="two-factor-logo" src={props.logo} alt="Logo" />}
            </div>
            {props.message && <p className="title-text text-center">{props.message}</p>}
            <Form formData={props.form} onFormSubmit={onFormSubmit} onFormChange={onFormChange}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFactorLogin;
